export default __webpack_public_path__ + "static/media/back-button-small.25451deb.svg";